// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"646":"3bbbd848","703":"4a01edae"}[chunkId] + ".chunk.js";
};